import React, { memo } from "react";
import { Link } from "react-router-dom";

function ResultQualityNotice(
  {
    messages = [],
    hints = [],
    hintsTitle = "",
    linkTo = "",
    onLinkClick = null,
    ctaLabel = "",
    className = "mt-auto w-full pb-2 flex flex-col gap-2",
    linkClassName = "outlined-button-small self-center",
  },
) {
  const noticeMessages = Array.isArray(messages) ? messages.filter(Boolean) : [];
  const noticeHints = Array.isArray(hints) ? hints.filter(Boolean) : [];

  if (!noticeMessages.length && !noticeHints.length) {
    return null;
  }

  return (
    <div className={className}>
      {noticeMessages.map((message, index) => (
        <div
          key={`${message.title || "message"}-${index}`}
          className="muted-text"
        >
          {message.title} {message.subtitle}
        </div>
      ))}

      {noticeHints.length ? (
        <div className="w-full max-w-md text-left">
          {hintsTitle ? (
            <p className="muted-text font-medium mb-1">{hintsTitle}</p>
          ) : null}
          <ul className="list-disc pl-5 flex flex-col gap-1">
            {noticeHints.map((hint) => (
              <li key={hint} className="muted-text">
                {hint}
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {linkTo ? (
        <Link
          to={linkTo}
          className={linkClassName}
          onClick={onLinkClick || undefined}
        >
          {ctaLabel}
        </Link>
      ) : null}
    </div>
  );
}

export default memo(ResultQualityNotice);
